import { Component, OnInit, OnChanges, Input } from '@angular/core';
import {
  ObjectValueAccessor,
  CreateObjectValueAccessorProvider,
  CreateObjectValueValidationProvider,
} from 'src/app/shared/widgets/value-accessors/object-value-accessor';
import { ProfileService } from '../../shared/profile.service';
import { EmailAddressType } from '../../shared/email-address-type.model';
import { ProfileEmailAddress } from '../../shared/model/profile-email-address.model';

@Component({
  selector: 'wl-profile-edit-emails',
  templateUrl: './profile-edit-emails.component.html',
  providers: [
    CreateObjectValueAccessorProvider(ProfileEditEmailsComponent),
    CreateObjectValueValidationProvider(ProfileEditEmailsComponent),
  ],
    standalone: false
})
export class ProfileEditEmailsComponent extends ObjectValueAccessor<Array<ProfileEmailAddress>> implements OnInit, OnChanges {
  @Input() profileId: number;

  public emailAddressTypes = new Array<EmailAddressType>();

  constructor(private _profileService: ProfileService) {
    super([], false);
  }

  ngOnInit() {
    this._profileService.getEmailAddressTypes().then(data => {
      this.emailAddressTypes = data;
    });
  }

  ngOnChanges() {
    if (this.profileId) {
      this._profileService.getProfileEmailAddresses(this.profileId).then(data => {
        this.value = data;
        setTimeout(() => {
          this.setPristine();
        }, 500);
      });
    }
  }

  addEmail() {
    this.value.push({} as ProfileEmailAddress);
  }

  deleteEmailAddress(i: number) {
    this.value.splice(i, 1);
  }

  addressTypeComparator(a: EmailAddressType, b: EmailAddressType) {
    if (!a || !b) {
      return false;
    }

    return a.EmailAddressTypeID === b.EmailAddressTypeID;
  }

  save() {
    const unchangedEmailAddresses: Array<ProfileEmailAddress> = JSON.parse(this.pristineValue);
    const deletedEmailAddresses: Array<ProfileEmailAddress> = unchangedEmailAddresses.filter(
      x => !this.value.some(a => x.ProfileEmailAddressID == a.ProfileEmailAddressID)
    );
    const emailPromises: any[] = [];

    for (let email of this.value) {
      if (email.ProfileEmailAddressID > 0) {
        let originalEmail: ProfileEmailAddress = unchangedEmailAddresses.find(x => x.ProfileEmailAddressID == email.ProfileEmailAddressID);
        if (originalEmail && JSON.stringify(originalEmail) != JSON.stringify(email)) {
          emailPromises.push(this._profileService.updateProfileEmailAddress(email));
        }
      }

      if (!email.ProfileEmailAddressID) {
        email.ProfileID = this.profileId;
        emailPromises.push(
          this._profileService.createProfileEmailAddress(email).then(data => {
            email.ProfileEmailAddressID = data;
          })
        );
      }
    }

    for (let email of deletedEmailAddresses) {
      emailPromises.push(this._profileService.deleteProfileEmailAddress(email));
    }

    return Promise.all(emailPromises).then(() => {
      this.setPristine();
    });
  }
}
